import { makeStyles, tokens } from '@fluentui/react-components';

export const useCardStepBattleLayoutStyles = makeStyles({
  stepBattleImageBackground: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: tokens.colorBrandBackgroundInverted,
  },
  header: {
    height: 'auto',
  },
});
